import { ActionIcon, Image, Stack, Tooltip } from "@mantine/core";
import { modals } from "@mantine/modals";
import NodePanelAdvanced from "../panel/NodePanelAdvanced";
import settingIcon from "../../../../../../assets/icons/settings-icon.png";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";

const NodeSettingsContent = ({ id }) => {
  const data = useFlowStore((s) => s.nodes.find((x) => x.id === id)?.data);
  return (
    <Stack gap={0}>
      <NodePanelAdvanced node={{ id, data }} />
    </Stack>
  );
};

const NodeSettings = ({ id }) => {
  const lang = useLanguage((s) => s.language);

  const handleClick = () => {
    modals.open({
      modalId: "node-settings",
      title: lang.campaign.step_settings,
      size: "80%",
      children: <NodeSettingsContent id={id} />,
    });
  };

  return (
    <Tooltip label={lang.campaign.step_settings}>
      <ActionIcon
        variant="subtle"
        pos={"absolute"}
        left={8}
        top={8}
        style={{ zIndex: 8 }}
        onClick={handleClick}
        size={"md"}
        color="#4664e2"
        radius={"xl"}
      >
        <Image src={settingIcon} />
      </ActionIcon>
    </Tooltip>
  );
};

export default NodeSettings;
